import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import {
  CampaignModuleStatusEnum,
  ResourceTypeDetailEnum,
  ResourceTypeEnum,
} from 'src/shared/enums';
import {
  IChallengeCheckoutPayment,
  IChallengeCheckoutPaymentProduct,
} from 'src/shared/models';

const {
  CHECKOUT_PRODUCT_ITEM_DESCRIPTION,
  CHECKOUT_PAYMENT_DESCRIPTION,
  CHECKOUT_PAYMENT_QUESTION,
  CHECKOUT_PAYMENT_BUTTON_NAME,
  CHECKOUT_PAYMENT_COMPLETED_LABEL,
  CHECKOUT_PAYMENT_TERMS,
  CHECKOUT_PAYMENT_TERMS_LABEL,
  CHECKOUT_PAYMENT_PRODUCT_IMAGE,
  CHECKOUT_PAYMENT_PRODUCT_PRICE,
  CHECKOUT_PAYMENT_PRODUCT_POINTS,
  CHECKOUT_PAYMENT_PRODUCT_EAN,
  CHECKOUT_PAYMENT_PRODUCT_CURRENT_STOCK,
} = ResourceTypeDetailEnum;

const { CHECKOUT_PAYMENT_GATEWAY_PRODUCT } = ResourceTypeEnum;

const getCompletedCheckoutInfo = (resource: IResourceList) => {
  let completeCheckoutInfo: {
    sapCustomerId: string | null;
    qrUrl: string | null;
    idSelectedProduct: number | null;
    checkoutId: number | null;
  } = {
    sapCustomerId: null,
    qrUrl: null,
    idSelectedProduct: null,
    checkoutId: null,
  };

  const userResource = resource.usersM2MList.find(
    ({ status, statusResource }) => {
      return status && statusResource === CampaignModuleStatusEnum.GENERIC_DONE;
    },
  );

  if (userResource?.value) {
    const extraData = JSON.parse(userResource.value);
    completeCheckoutInfo = {
      qrUrl: extraData?.checkout?.qr || null,
      sapCustomerId: extraData?.checkout?.S_CODDROPPOINT || null,
      idSelectedProduct: extraData?.checkout?.idResource || null,
      checkoutId: extraData?.checkout?.BSTKD || null,
    };
  }

  return completeCheckoutInfo;
};

const getProductMoney = (resource: IResourceList) => {
  let money: number;
  resource.resourceList.forEach(
    ({ idResourceType: { idResourceType }, resourceDetailList }) => {
      if (idResourceType === CHECKOUT_PAYMENT_GATEWAY_PRODUCT) {
        resourceDetailList.forEach(
          ({ idResourceTypeD: { idResourceTypeD }, value, status }) => {
            if (idResourceTypeD === CHECKOUT_PAYMENT_PRODUCT_PRICE && status === true) {
              money = +value;
            }
          },
        );
      }
    },
  );
  return money || 0;
};

const getProductPoints = (resource: IResourceList) => {
  let points: number;
  resource.resourceDetailList.forEach(
    ({ idResourceTypeD: { idResourceTypeD }, value, status }) => {
      if (idResourceTypeD === CHECKOUT_PAYMENT_PRODUCT_POINTS && status === true) {
        points = +value;
      }
    },
  );
  return points || 0;
};

const getCheckoutProduct = ({
  resourceDetailList,
  name: lead,
  idResource,
  idResourceType,
}: IResourceList): IChallengeCheckoutPaymentProduct => {
  let product: IChallengeCheckoutPaymentProduct;
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value, status }) => {
      if (idResourceType.idResourceType === CHECKOUT_PAYMENT_GATEWAY_PRODUCT, status === true) {
        switch (idResourceTypeD) {
          case CHECKOUT_PAYMENT_PRODUCT_EAN:
            product = {
              ...product,
              id: value,
            };
            break;
          case CHECKOUT_PAYMENT_PRODUCT_IMAGE:
            product = {
              ...product,
              img: value,
            };
            break;
          case CHECKOUT_PAYMENT_PRODUCT_CURRENT_STOCK:
            product = {
              ...product,
              stock: +value || 0,
            };
            break;
          case CHECKOUT_PRODUCT_ITEM_DESCRIPTION:
            product = {
              ...product,
              description: value,
            };
            break;
          case CHECKOUT_PAYMENT_PRODUCT_PRICE:
            product = {
              ...product,
              price: +value || 0,
            };
            break;
        }
      }
    });
  return { ...product, lead, idResource };
};

export const buildChallengeCheckoutPayment = (
  resource: IResourceList,
): IChallengeCheckoutPayment => {
  const {
    resourceDetailList,
    name: title,
    idResource,
    resourceList,
  } = resource;
  let item: IChallengeCheckoutPayment;
  let money = getProductMoney(resource);
  let points = getProductPoints(resource);
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case CHECKOUT_PAYMENT_DESCRIPTION:
          item = {
            ...item,
            checkoutName: value,
          };
          break;
        case CHECKOUT_PAYMENT_QUESTION:
          item = {
            ...item,
            lead: value,
          };
          break;
        case CHECKOUT_PAYMENT_BUTTON_NAME:
          item = {
            ...item,
            buttonName: value,
          };
          break;
        case CHECKOUT_PAYMENT_COMPLETED_LABEL:
          item = {
            ...item,
            completedLabel: value,
          };
          break;
        case CHECKOUT_PAYMENT_PRODUCT_IMAGE:
          item = {
            ...item,
            productImage: value,
          };
          break;
        case CHECKOUT_PAYMENT_TERMS_LABEL:
          item = { ...item, termsLabel: value };
          break;
        case CHECKOUT_PAYMENT_TERMS:
          item = { ...item, termsUrl: value };
          break;
      }
    });
  const arrProducts: IChallengeCheckoutPaymentProduct[] = resourceList
    ?.filter(
      ({ idResourceType: { idResourceType } }) =>
        ![
          ResourceTypeEnum.EMAIL_WITH_DELAY,
          ResourceTypeEnum.EMAIL_WITH_DATE,
        ].includes(idResourceType),
    )
    ?.map((resource) => getCheckoutProduct(resource));

  let product = arrProducts.length === 1 ? arrProducts[0] : null;
  product = { ...product, score: getProductPoints(resource) };

  const completeCheckoutInfo = getCompletedCheckoutInfo(resource);
  return {
    ...item,
    title,
    idResource,
    product,
    ...completeCheckoutInfo,
    points,
    money,
  };
};
